<div class="flex flex-col gap-8 m-8">
  @if (expertStore.experts$ | async; as observables) {
    <div class="statistics mat-typography flex flex-col gt-sm:flex-row">
      <mat-card
        class="stat-card flex-1 gap-3"
        style="background-color: #57cf69"
        data-test-id="statistics-new-profiles"
        (click)="adjustTab(1)"
      >
        <div class="title" data-test-id="statistics-new-profiles-title">
          New Profiles to review
        </div>
        <div
          class="central-container"
          data-test-id="statistics-new-profiles-count"
        >
          {{ observables.newExperts.length }}
        </div>
        <div class="flex">
          <div class="review" data-test-id="statistics-new-profiles-subtitle">
            Review your new profiles
          </div>
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </mat-card>
      <mat-card
        class="stat-card flex-1 gap-3"
        style="background-color: #1e2b4e"
        data-test-id="statistics-scheduled-profiles"
        (click)="adjustTab(2)"
      >
        <div class="title" data-test-id="statistics-scheduled-profiles-title">
          Scheduled Connections
        </div>
        <div
          class="central-container"
          data-test-id="statistics-scheduled-profiles-count"
        >
          {{ observables.acceptedExperts.length }}
        </div>
        <div class="flex">
          <div
            class="review"
            data-test-id="statistics-scheduled-profiles-subtitle"
          >
            Review scheduled profiles
          </div>
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </mat-card>
      <mat-card
        class="stat-card flex-1 gap-3"
        style="background-color: #b5bfcc"
        data-test-id="statistics-completed-profiles"
        (click)="adjustTab(3)"
      >
        <div class="title" data-test-id="statistics-completed-profiles-title">
          Completed Connections
        </div>
        <div
          class="central-container"
          data-test-id="statistics-completed-profiles-count"
        >
          {{ observables.completedConnections.length }}
        </div>
        <div class="flex">
          <div
            class="review"
            data-test-id="statistics-completed-profiles-subtitle"
          >
            View completed profiles
          </div>
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </mat-card>
    </div>
  }

  <div class="progress-container flex flex-col gap-2">
    <div class="progress-header flex justify-between items-center">
      <div>
        <h4>Project keywords</h4>
        <span>Add project keywords to improve transcript accuracy.</span>
      </div>
      <button mat-flat-button color="primary" (click)="manageKeywords()">
        <mat-icon class="secondaryColor">text_snippet</mat-icon>
        <span>Manage keywords</span>
      </button>
    </div>
  </div>

  @if (emptyExperts && showOmnisearchBanner) {
    <div
      class="flex justify-center content-center"
      data-test-id="geographic-progress-omnisearch-banner"
    >
      <mat-card class="omnisearch-banner primaryColorBG">
        <mat-card-content>
          Want a head start on scheduling expert calls? Use
          <b
            class="omnisearch secondaryColor"
            data-test-id="geographic-progress-omnisearch-banner-link"
            (click)="openOmnisearch.emit()"
            >Omnisearch</b
          >
          to see if your colleagues have spoken with similar experts
        </mat-card-content>
      </mat-card>
    </div>
  }

  <div
    class="progress-container flex flex-col gap-2"
    data-test-id="project-progress-tracker"
  >
    @if (emptyExperts) {
      <img
        class="empty-progress"
        src="./../../../../assets/images/empty-progress.png"
        data-test-id="geographic-progress-empty-progress-image"
      />
    } @else {
      <div class="progress-header flex justify-between items-center">
        <h4>Project Progress Tracker</h4>
        <button
          mat-stroked-button
          color="primary"
          class="flex export primaryColor-border"
          data-test-id="geographic-progress-export"
          (click)="downloadProgressCsv()"
        >
          <mat-icon>ic_file_download</mat-icon>
          <span data-test-id="geographic-progress-export-label"
            >Export progress</span
          >
        </button>
      </div>

      <table
        class="mat-typography"
        mat-table
        matSort
        data-test-id="geographic-progress-segment-table"
        [dataSource]="dataSource"
      >
        <ng-container matColumnDef="summary">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
            matTooltip="Segment summaries are available once you have completed your first call for that segment"
          >
            <span>Summaries</span>
            <mat-icon>info_outline</mat-icon>
          </th>
          <td *matCellDef="let element" mat-cell>
            <button
              mat-button
              color="primary"
              class="export"
              data-test-id="geographic-progress-download-segment-summary"
              [disabled]="!element.transcriptionSummaryKey"
              (click)="downloadSummary(element)"
            >
              <mat-icon>ic_file_download</mat-icon>
              <span
                data-test-id="geographic-progress-download-segment-summary-label"
              >
                Download
              </span>
            </button>
          </td>
          <td *matFooterCellDef mat-footer-cell>TOTAL</td>
        </ng-container>
        <ng-container matColumnDef="geography">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Geography</th>
          <td
            *matCellDef="let element"
            mat-cell
            data-test-id="geographic-progress-segment-summary-table-geography"
          >
            {{ element.geography }}
          </td>
          <td *matFooterCellDef mat-footer-cell></td>
        </ng-container>
        <ng-container matColumnDef="segment">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>
            Profile Type
          </th>
          <td
            *matCellDef="let element"
            mat-cell
            data-test-id="geographic-progress-segment-summary-table-profile-type"
          >
            {{ element.segment }}
          </td>
          <td *matFooterCellDef mat-footer-cell></td>
        </ng-container>
        <ng-container matColumnDef="screening">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Screening</th>
          <td
            *matCellDef="let element"
            mat-cell
            data-test-id="geographic-progress-segment-summary-table-screening"
          >
            <div class="center-align">{{ element.screening }}</div>
          </td>
          <td
            *matFooterCellDef
            mat-footer-cell
            data-test-id="geographic-progress-segment-summary-table-screening-total"
          >
            <div class="center-align">
              <div class="total">
                {{ opportunity.opportunitySegmentStatsTotal?.screening }}
              </div>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="inPortal">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>New</th>
          <td
            *matCellDef="let element"
            mat-cell
            data-test-id="geographic-progress-segment-summary-table-in-portal"
          >
            <div class="center-align">{{ element.inPortal }}</div>
          </td>
          <td
            *matFooterCellDef
            mat-footer-cell
            data-test-id="geographic-progress-segment-summary-table-in-portal-total"
          >
            <div class="center-align">
              <div class="total">
                {{ opportunity.opportunitySegmentStatsTotal?.inPortal }}
              </div>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="scheduled">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>
            <span>Upcoming</span>
          </th>
          <td
            *matCellDef="let element"
            mat-cell
            data-test-id="geographic-progress-segment-summary-table-upcoming"
          >
            <div class="center-align">
              {{ element.scheduled }}
            </div>
          </td>
          <td
            *matFooterCellDef
            mat-footer-cell
            data-test-id="geographic-progress-segment-summary-table-upcoming-total"
          >
            <div class="center-align">
              <div class="total">
                {{ opportunity.opportunitySegmentStatsTotal?.scheduled }}
              </div>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="completed">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Completed</th>
          <td
            *matCellDef="let element"
            mat-cell
            data-test-id="geographic-progress-segment-summary-table-completed"
          >
            <div class="center-align">{{ element.completed }}</div>
          </td>
          <td
            *matFooterCellDef
            mat-footer-cell
            data-test-id="geographic-progress-segment-summary-table-completed-total"
          >
            <div class="center-align">
              <div class="total">
                {{ opportunity.opportunitySegmentStatsTotal?.completed }}
              </div>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="confirmed">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
            matTooltip="Confirmed connections is the total number of scheduled and completed calls"
            data-test-id="geographic-progress-segment-summary-table-confirmed-header"
          >
            <b style="color: black">Confirmed</b>
            <mat-icon>info_outline</mat-icon>
          </th>
          <td
            *matCellDef="let element"
            mat-cell
            data-test-id="geographic-progress-segment-summary-table-confirmed"
          >
            <div class="center-align">{{ element.confirmed }}</div>
          </td>
          <td
            *matFooterCellDef
            mat-footer-cell
            data-test-id="geographic-progress-segment-summary-table-confirmed-total"
          >
            <div class="center-align">
              <div class="total">
                <b>{{ opportunity.opportunitySegmentStatsTotal?.confirmed }}</b>
              </div>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="target">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>
            <b style="color: black">Target</b>
          </th>
          <td
            *matCellDef="let element"
            mat-cell
            data-test-id="geographic-progress-segment-summary-table-target"
          >
            <div class="center-align">
              <div class="center-align">
                <div class="total">
                  <b>{{ element.target }}</b>
                </div>
              </div>
            </div>
          </td>
          <td
            *matFooterCellDef
            mat-footer-cell
            data-test-id="geographic-progress-segment-summary-table-target-total"
          >
            <div class="center-align">
              <div class="total">
                <b>{{ opportunity.opportunitySegmentStatsTotal?.target }}</b>
              </div>
            </div>
          </td>
        </ng-container>
        <tr
          *matHeaderRowDef="displayedColumns"
          mat-header-row
          class="header-row"
        ></tr>
        <tr
          *matRowDef="let row; columns: displayedColumns"
          mat-row
          class="body-row"
          [attr.data-test-id]="
            'geographic-progress-segment-summary-table-row-' +
            row.opportunitySegmentId
          "
        ></tr>
        <tr
          *matFooterRowDef="displayedColumns"
          mat-footer-row
          class="footer-row"
        ></tr>
      </table>
    }
  </div>
</div>
